import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');

export default function Index({ item }: any) {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('landingPage');
    const { img, title, url } = item;

    const openHandle = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: title.replaceAll('\n', ' '),
                position: `Solution Page_${t('secE_item3_title_1')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        url && window.open(url);
    };

    return (
        <div className={css.swiperCard2}>
            <div className="content">
                <div className="img-box">
                    <EFPic name={img} noUseSrcset alt={t(title)} />
                </div>
                <div className="title">{t(title)}</div>
                <div className="options" onClick={() => openHandle()}>
                    <div className="learn-more">{t('learn_more')}</div>
                </div>
            </div>
        </div>
    );
}
